(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/interactions/:cardId', {
      templateUrl: 'modules/app/interactions/interactions-detail.html',
      controller: 'InteractionsCardCtrl',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/interactions/:cardId/top', {
      templateUrl: 'modules/app/interactions/interactions-card.html',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
    $routeProvider.when('/share/:shareKey/interactions/:cardId', {
      templateUrl: 'modules/app/interactions/interactions-detail.html',
      controller: 'InteractionsCardCtrl',
      resolve: {
        shares: ['ShareUtils', '$route', function (ShareUtils, $route) {
          ShareUtils.getShare($route.current.params.shareKey);
        }],
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "interactions": "interactions"
    });
  }]).
  /*
   * Interactions Card
   * */
  controller('InteractionsCardCtrl', ['$location', '$q', '$routeParams', '$scope', 'CardRegistry', 'CardUtils', 'Interactions', 'QueryES', 'CardQueryResource', function ($location, $q, $routeParams, $scope, CardRegistry, CardUtils, Interactions, QueryES, CardQueryResource) {
    CardUtils.setNavElements($scope, $routeParams.cardId, $routeParams.cardId);

    // ------------------------------------------
    // Setup for interactions directive
    // ------------------------------------------

    $scope.cardId = $routeParams.cardId;
    if ($scope.cardToPreview) {
      $scope.isPreview = true;
      $scope.isDetail = false;
    } else if ($routeParams.cardId && $location.path().indexOf("interactions") >= 0) {
      $scope.isPreview = $routeParams.cardId === 'preview';
      $scope.isDetail = true;
    }
    if ($scope.isDetail) {
      $scope.card = CardRegistry.get($routeParams.cardId);
    } else if ($scope.isPreview) {
      $scope.card = $scope.cardToPreview;
    }

    // Details url if necessary
    if (!$scope.isDetail && !$scope.isPreview) {
      $scope.detailsUrl = CardUtils.getCardUrl($scope.card);
    }
    var countParams = {};
    if ($scope.isPreview) {
      countParams.config = $scope.card.configuration;
    } else {
      countParams.cardId = $scope.card.id;
    }
    $scope.defaultSummary = "0 interactions";
    Interactions.count(countParams, $scope.isPreview).then(function (count) {
      // format with toLocalString to add commas
      $scope.defaultSummary = Number(count).toLocaleString() + " interactions";
      $scope.hasData = count > 0;
    }, function () {
      $scope.hasData = false;
    });
    $scope.subDetails = [];
    if (!$scope.isPreview) {
      $scope.subDetails = [{
        text: "Download data",
        downloadData: true,
        tooltip: "Download data tables",
        href: CardQueryResource.getDownloadUrl('interactions/csv', $scope.card.id, $scope.card.configuration)
      }, {
        text: "Download Statements",
        tooltip: "Download interaction statements",
        href: QueryES.queryExportUrl($scope.cardId === 'preview' ? $scope.card.configuration.filter : $scope.cardId, true, 'interactions')
      }];
    }
  }]).controller('InteractionsConfigurationCtrl', ["$scope", function ($scope) {
    $scope.workingConfig.type = "interactions";
    $scope.$watch("workingConfig.actualDate", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
  }]);
})();
